import React, { useEffect, useState } from 'react'
// import moment from 'moment'
// import 'moment-timezone'
import moment from 'moment-timezone'
import { connect } from 'react-redux'
import noop from 'lodash/noop'
import PropTypes from 'prop-types'
import { globalKeyStore } from '../../redux/actions/globalState'
import { EMPTY_ARRAY } from '../../constants/globalConstants'
import { getActiveDatesCalendar, getConvertedDate } from '../../utils/helper'

function Calendar2({ handleSelectingDate, dispatch, selectedYearForLabel, allEventsData, handleFaciltyChange, setCurrMonthLoc }) {

    const [monthDaysArray, setMonthDaysArray] = useState([])
    const [selDate, setSelDate] = useState()
    const [monthShow, setMonthShow] = useState()
    const [currentMonthFull, setCurrentMonthFull] = useState()
    const [currentFullDate, setFullCurrentDate] = useState()
    const [nextMonthNameDate, setNextMonthNameDate] = useState()
    const [isPreviousButton, setIsPreviousButton] = useState(false)
    const [todayDt, setTodayDt] = useState(null)
    useEffect(() => {
        const localTimeZone = localStorage.getItem('facilitiesTimezone') || 'America/New_York'
        const mom = new moment(getConvertedDate(moment(new Date()).format('YYYY-MM-DD hh:mm:ss'))).tz(`${localTimeZone}`)
        // console.log(mom.date(), 'mom')
        setTodayDt(mom.date())
        const currentMonth = moment(getConvertedDate(moment(new Date()).format('YYYY-MM-DD hh:mm:ss'))).tz(`${localTimeZone}`).month()
        mom.set('month', currentMonth) // 0-indexed, so 3 --> 4 --> April

        if (!selectedYearForLabel) {
            const daysInMonth = moment(getConvertedDate(moment(new Date()).format('YYYY-MM-DD hh:mm:ss'))).tz(`${localTimeZone}`).daysInMonth()
            const curMonth = moment(getConvertedDate(moment(new Date()).format('YYYY-MM-DD hh:mm:ss'))).tz(`${localTimeZone}`).month()
            const curYear = moment(getConvertedDate(moment(new Date()).format('YYYY-MM-DD hh:mm:ss'))).tz(`${localTimeZone}`).year()
            const monthDaysArray = getActiveDatesCalendar(daysInMonth, allEventsData, curMonth, curYear)
            setMonthDaysArray(monthDaysArray)

            // current month 
            const currentMonthShortName = moment(getConvertedDate(moment(new Date()).format('YYYY-MM-DD hh:mm:ss'))).tz(`${localTimeZone}`).format('MMM')
            const currentMonthFullName = moment(getConvertedDate(moment(new Date()).format('YYYY-MM-DD hh:mm:ss'))).tz(`${localTimeZone}`).add(1, 'months').format('MMMM')
            const nextMonthName = moment(getConvertedDate(moment(new Date()).format('YYYY-MM-DD hh:mm:ss'))).tz(`${localTimeZone}`).add(1, 'months')
            setNextMonthNameDate(nextMonthName)
            setCurrentMonthFull(currentMonthFullName)
            setMonthShow(currentMonthShortName)


            const currentFullDateShow = moment(getConvertedDate(moment(new Date()).format('YYYY-MM-DD hh:mm:ss'))).tz(`${localTimeZone}`)
            setFullCurrentDate(currentFullDateShow)
        } else {
            const daysInMonth = moment(new Date(selectedYearForLabel)).daysInMonth()
            const curMonth = moment(new Date(selectedYearForLabel)).month()
            const curYear = moment(new Date(selectedYearForLabel)).year()
            const monthDaysArray = getActiveDatesCalendar(daysInMonth, allEventsData, curMonth, curYear)
            setMonthDaysArray(monthDaysArray)

            // current month 
            const currentMonthShortName = moment(new Date(selectedYearForLabel), 'YYYY/MM/DD').format('MMM')
            const currentMonthFullName = moment(new Date(selectedYearForLabel), 'YYYY/MM/DD').add(1, 'months').format('MMMM')
            const nextMonthName = moment(new Date(selectedYearForLabel), 'YYYY/MM/DD').add(1, 'months')
            setNextMonthNameDate(nextMonthName)
            setCurrentMonthFull(currentMonthFullName)
            setMonthShow(currentMonthShortName)

            const currentFullDateShow = moment(new Date(selectedYearForLabel))
            setFullCurrentDate(currentFullDateShow)
        }

        // new logic set now
        const currentDate = moment(new Date()).tz(`${localTimeZone}`).format('YYYY-MM')
        if (currentDate < moment(new Date(selectedYearForLabel)).format('YYYY-MM')) {
            setIsPreviousButton(true)
        } else {
            setIsPreviousButton(false)
        }

        // selected Date in calender
        const defaultSelectedDate = selectedYearForLabel ? moment(new Date(selectedYearForLabel)).format('D') : moment(getConvertedDate(moment(new Date()).format('YYYY-MM-DD hh:mm:ss'))).tz(`${localTimeZone}`).format('D')
        // setSelDate(defaultSelectedDate)

        dispatch(globalKeyStore({ selectedYearForLabel: selectedYearForLabel ? moment(selectedYearForLabel)?.format('YYYY/MM/D') : `${moment(getConvertedDate(moment(new Date()).format('YYYY-MM-DD hh:mm:ss'))).tz(`${localTimeZone}`)?.format('YYYY/MM/D')}` }))
        // console.log(selectedYearForLabel, 'Date checking in safari')
        // default scroll

        // const SafariDate = moment(getConvertedDate(moment(new Date()).format('YYYY-MM-DD hh:mm:ss'))).tz(`${localTimeZone}`)?.format('YYYY/MM/D')

        // console.log(moment(new Date(SafariDate))?.format('YYYY/MM/D'), SafariDate, 'selectedYearForLabel')
        setTimeout(() => {
            handleCenterCalendar('radio_parent_' + (defaultSelectedDate - 1), true)
            // console.log(allEventsData, 'allEventsData')
        }, 0)
    }, [allEventsData])
    
    const handleDateSelect = (e, ind) => {
        // const localTimeZone = localStorage.getItem('facilitiesTimezone')
        setSelDate(e.target.value)
        let currentDate
        const dayValue = e.target.value 
        const monthYear = String(moment(currentFullDate).format('YYYY-MM'))?.split('-')
        const newDate = new Date(monthYear[0], monthYear[1]-1 ,dayValue) //Sets the new Date with the desired Date passed
        currentDate = moment(newDate).format('YYYY-MM-DD')
        handleSelectingDate(currentDate)
        handleCenterCalendar('radio_parent_' + ind, false)
    }

    const handleCenterCalendar = (DateID, noslide=false) => {
        const container = document.getElementById('calender_scroll')
        const middle = document.getElementById(DateID)
        if (container && noslide == true) {
            container.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth'
            })
        } else if ((container && middle) && noslide == false) {
            // container.scrollLeft = middle?.offsetLeft + middle?.offsetWidth / 2 - container?.offsetWidth / 2
            // Bellow Code is for smooth scroll and above code is for fast scroll
            container.scrollTo({
                top: 0,
                left: middle?.offsetLeft + middle?.offsetWidth / 2 - container?.offsetWidth / 2,
                behavior: 'smooth'
            })
        }
    }

    const handleNext = () => {
        const localFacilityId = localStorage.getItem('selectedFacilityId')
        const localTimeZone = localStorage.getItem('facilitiesTimezone') || 'America/New_York'
        const mom = new moment(new Date(currentFullDate)).tz(`${localTimeZone}`)
        const currentMonth = moment(new Date(currentFullDate)).tz(`${localTimeZone}`).month()
        const currentYear = moment(new Date(currentFullDate)).tz(`${localTimeZone}`).year()
        handleFaciltyChange(localFacilityId, currentMonth+1, currentYear)
        if (Number(currentMonth) == 11) {
            mom.set('month', 0)
        } else {
            mom.set('month', currentMonth + 1) // 0-indexed, so 3 --> 4 --> April
        }
        // console.log(mom, 'mom')
        setCurrMonthLoc(mom.format('MMM')+'-'+currentYear)

        // for the days in month
        const daysInMonth = moment(new Date(currentFullDate), 'YYYY/MM/DD').tz(`${localTimeZone}`).add(1, 'months').daysInMonth()
        const curMonth = moment(new Date(currentFullDate), 'YYYY/MM/DD').tz(`${localTimeZone}`).add(1, 'months').month()
        const curYear = moment(new Date(currentFullDate), 'YYYY/MM/DD').tz(`${localTimeZone}`).add(1, 'months').year()
        // console.log(daysInMonth, 'daysInMonth')
        const monthDaysArray = getActiveDatesCalendar(daysInMonth, allEventsData, curMonth, curYear)
        setMonthDaysArray(monthDaysArray)

        // selected Date in calender
        // const defaultSelectedDate = moment(new Date(currentFullDate), 'YYYY/MM/DD').tz(`${localTimeZone}`).add(1, 'months').startOf('month').format('D')

        setSelDate('')

        // current month 
        const currentMonthShortName = moment(new Date(currentFullDate), 'YYYY/MM/DD').tz(`${localTimeZone}`).add(1, 'months').format('MMM')
        const currentMonthFullName = moment(new Date(nextMonthNameDate), 'YYYY/MM/DD').tz(`${localTimeZone}`).add(1, 'months').format('MMMM')
        setMonthShow(currentMonthShortName)
        setCurrentMonthFull(currentMonthFullName)

        // next month find
        const nextMonthName = moment(new Date(nextMonthNameDate), 'YYYY/MM/DD').tz(`${localTimeZone}`).add(1, 'months')
        setNextMonthNameDate(nextMonthName)

        // Full next date 
        const currentFullDateShow = moment(new Date(currentFullDate)).tz(`${localTimeZone}`).add(1, 'months')
        setFullCurrentDate(currentFullDateShow)
        const newDate = new Date(selectedYearForLabel) //Sets the new Date with the desired Date passed
        const nextMonth = moment(newDate).add(1, 'months').format('YYYY-MM-DD')
        dispatch(globalKeyStore({ selectedYearForLabel: nextMonth
            // `${moment(new Date(selectedYearForLabel)).add(1, 'months').year()}-${Number(moment(new Date(selectedYearForLabel)).add(1, 'months').format('MM'))}-${moment(new Date(selectedYearForLabel)).add(1, 'months').format('D')}` 
        }))

        // for pervious button 
        setIsPreviousButton(true)
        handleCenterCalendar('radio_parent_1', true)
    }

    const handlePrevious = () => {
        const localFacilityId = localStorage.getItem('selectedFacilityId')
        const localTimeZone = localStorage.getItem('facilitiesTimezone') || 'America/New_York'
        const mom = new moment(new Date(currentFullDate)).tz(`${localTimeZone}`)
        const currentMonth = moment(new Date(currentFullDate)).tz(`${localTimeZone}`).month()
        const currentYear = moment(new Date(currentFullDate)).tz(`${localTimeZone}`).year()
        handleFaciltyChange(localFacilityId, currentMonth - 1, currentYear)
        if (Number(currentMonth) == 0) {
            mom.set('month', 11)
        } else {
            mom.set('month', currentMonth - 1) // 0-indexed, so 3 --> 4 --> April
        }
        setCurrMonthLoc(mom.format('MMM')+'-'+currentYear)

        const updatedSelectedDate = moment(new Date(currentFullDate)).tz(`${localTimeZone}`).subtract(1, 'months')
        setFullCurrentDate(updatedSelectedDate)


        // new logic set now
        const currentDate = moment(new Date()).tz(`${localTimeZone}`).format('YYYY-MM')

        if (currentDate < moment(updatedSelectedDate).tz(`${localTimeZone}`).format('YYYY-MM')) {
            setIsPreviousButton(true)
        } else {
            setIsPreviousButton(false)
        }

        // new logic end


        // for the days in month
        const daysInMonth = moment(new Date(currentFullDate), 'YYYY/MM/DD').tz(`${localTimeZone}`).subtract(1, 'months').daysInMonth()
        const curMonth = moment(new Date(currentFullDate), 'YYYY/MM/DD').tz(`${localTimeZone}`).subtract(1, 'months').month()
        const curYear = moment(new Date(currentFullDate), 'YYYY/MM/DD').tz(`${localTimeZone}`).subtract(1, 'months').year()
        const monthDaysArray = getActiveDatesCalendar(daysInMonth, allEventsData, curMonth, curYear)
        setMonthDaysArray(monthDaysArray)

        setSelDate('')

        // current month 
        const currentMonthShortName = moment(new Date(currentFullDate), 'YYYY/MM/DD').tz(`${localTimeZone}`).subtract(1, 'months').format('MMM')
        const currentMonthFullName = moment(new Date(nextMonthNameDate), 'YYYY/MM/DD').tz(`${localTimeZone}`).subtract(1, 'months').format('MMMM')
        setMonthShow(currentMonthShortName)
        setCurrentMonthFull(currentMonthFullName)

        // next month find
        const nextMonthName = moment(new Date(nextMonthNameDate), 'YYYY/MM/DD').tz(`${localTimeZone}`).subtract(1, 'months')
        setNextMonthNameDate(nextMonthName)
        const newDate = new Date(selectedYearForLabel) //Sets the new Date with the desired Date passed
        const previousMonth = moment(newDate).subtract(1, 'months').format('YYYY-MM-DD')
        dispatch(globalKeyStore({ selectedYearForLabel: previousMonth
            // `${moment(new Date(updatedSelectedDate)).tz(`${localTimeZone}`).subtract(1, 'months').year()}-${Number(moment(new Date(currentFullDate)).tz(`${localTimeZone}`).subtract(1, 'months').format('MM'))}-${moment(new Date(currentFullDate)).tz(`${localTimeZone}`).subtract(1, 'months').format('D')}` 
        }))
        handleCenterCalendar('radio_parent_1', true)
    }

    return (
        <div className="row align-items-center">
            {(isPreviousButton) && <div className="col-sm-auto col-6 order-0 ">
                <button type='button' className="btn text-secondary" onClick={handlePrevious}><i className="fa fa-arrow-left"></i> {moment().month(currentMonthFull).subtract(2, 'months').format('MMMM')} </button>
            </div>}

            {/* main calender */}
            <div className="col-sm col-12 order-3 order-sm-1 dateWrapperSelector">
                <div className="text-center" role="group" id='calender_scroll' aria-label="Basic radio toggle">
                    {monthDaysArray?.map((item, index) => <span id={`radio_parent_${index}`} key={index}>
                        <input 
                            type="radio" 
                            className="btn-check" 
                            value={item?.date} 
                            name="btnradio" 
                            id={`btnradio${index}`} 
                            autoComplete="off" 
                            checked={Number(selDate) == item?.date} 
                            disabled={ (!isPreviousButton && (item?.date < Number(todayDt))) || item?.isDisabled } 
                            onChange={(e) => handleDateSelect(e, index)} 
                        />
                        <label className="btn px-3 btn-outline-primary" htmlFor={`btnradio${index}`}>
                            <h2 className="mb-0 fw-bold">{item?.date}</h2>
                            <span>{monthShow}</span>
                        </label>
                    </span>
                    )}
                </div>
            </div>

            {/* next arrow calender */}
            <div className="col-sm-auto col-6 order-2 order-sm-2 text-end">
                <button type='button' className="btn  text-primary " onClick={handleNext}>{currentMonthFull} <i className="fa fa-arrow-right"></i></button>
            </div>
        </div>
    )
}

Calendar2.propTypes = {
    dispatch: PropTypes.func,
    notify: PropTypes.func,
    handleSelectingDate: PropTypes.func,
    handleFaciltyChange: PropTypes.func,
    setCurrMonthLoc: PropTypes.func,
    selectedYearForLabel: PropTypes.string,
    allEventsData: PropTypes.array
}

Calendar2.defaulProps = {
    dispatch: noop,
    notify: noop,
    handleSelectingDate: noop,
    handleFaciltyChange: noop,
    setCurrMonthLoc: noop,
    selectedYearForLabel: '',
    allEventsData: EMPTY_ARRAY
}

function mapStateToProps({ globalReducers }) {
    return {
        selectedYearForLabel: globalReducers?.selectedYearForLabel,
        allEventsData: globalReducers?.allEventsData
    }
}

export default connect(mapStateToProps)(Calendar2)